module.exports = __webpack_public_path__ + "static/media/sketch.06a1dc88.png";